import { render, staticRenderFns } from "./HomeBackups.vue?vue&type=template&id=d52ebdcc&"
import script from "./HomeBackups.vue?vue&type=script&lang=js&"
export * from "./HomeBackups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports